import fieldConfig from "../config/fieldConfig";

export const sanitizePayload = (formData, tipo) => {
  const allowedFields = (fieldConfig[tipo] || []).map(f => f.name);
  const sanitized = {};

  for (const key of allowedFields) {
    if (Object.prototype.hasOwnProperty.call(formData, key)) {
      const val = formData[key];
      if (val === "" || val === undefined || (typeof val === "string" && val.trim() === "")) {
        sanitized[key] = null;
      } else {
        sanitized[key] = val;
      }
    }
  }
  if ("fecha_toma" in formData) {
    sanitized.fecha_toma = formData.fecha_toma || null;
  }
  if ("fecha_disponibilidad" in formData) {
    sanitized.fecha_disponibilidad = formData.fecha_disponibilidad || null;
  }

  return sanitized;
};